import { useState, useMemo, useLayoutEffect, memo } from "react";
import { countMaxLevel } from "./helpers";
import {
  DefaultItem,
  DestructureGetters,
  SectionNavigationNavListBuilderComponent,
  SectionNavigationNavListBuilderProps,
} from "./interfaces";
import ListBuilder from "./list-builder";

const SectionNavigationNavListBuilder = <T extends object>(
  props: SectionNavigationNavListBuilderProps<T>,
) => {
  const {
    items,
    getLabel,
    getId,
    getSubsections = (item: DefaultItem<T>) => item.subsections,
  } = props;

  const [renderLevel, setRenderLevel] = useState(0);

  const getters = useMemo(
    () => ({
      getId,
      getLabel,
      getSubsections,
    }),
    [getId, getLabel, getSubsections],
  ) as DestructureGetters<T>;

  const maxLevel = useMemo(
    () => countMaxLevel(items, getters),
    [getters, items],
  );

  useLayoutEffect(() => {
    if (renderLevel < maxLevel) {
      setRenderLevel((prevState) => prevState + 1);
    }
  }, [maxLevel, renderLevel]);

  return <ListBuilder {...props} renderLevel={renderLevel} getters={getters} />;
};

export default memo(
  SectionNavigationNavListBuilder,
) as SectionNavigationNavListBuilderComponent;
